import React, {useCallback} from 'react';
import {Add, Remove} from '@mui/icons-material';
import {TextField} from '@mui/material';
import IconButton from '../../../components/base/button/icon_button';
import useAccessLevels from '../../../hooks/use-access-levels';

const QuantityStepper = ({
                             value,
                             onChange,
                             disabled = false,
                             min,
                             max = 9999,
                         }) => {
    const operatorAccessLevels = useAccessLevels();
    const resolvedMin = min ?? (operatorAccessLevels.packages.sales.issueCredit ? -9999 : 0);

    const applyValue = useCallback((next) => {
        let parsed = operatorAccessLevels.packages.sales.allowDecimalQuantityInOrders
            ? parseFloat(next)
            : parseInt(next, 10);
        if (Number.isNaN(parsed)) {
            onChange(0);
            return;
        }
        if (!operatorAccessLevels.packages.sales.allowDecimalQuantityInOrders) {
            parsed = Math.trunc(parsed);
        }
        if (!operatorAccessLevels.packages.sales.issueCredit) {
            parsed = Math.max(parsed, 0);
        }
        parsed = Math.min(max, Math.max(resolvedMin, parsed));
        onChange(parsed);
    }, [
        max,
        onChange,
        operatorAccessLevels.packages.sales.allowDecimalQuantityInOrders,
        operatorAccessLevels.packages.sales.issueCredit,
        resolvedMin,
    ]);

    const decrease = useCallback(() => {
        const current = Number(value) || 0;
        if (current > resolvedMin) {
            applyValue(current - 1);
        }
    }, [applyValue, resolvedMin, value]);

    const increase = useCallback(() => {
        const current = Number(value) || 0;
        if (current < max) {
            applyValue(current + 1);
        }
    }, [applyValue, max, value]);

    return (
        <div className={'d-flex align-items-center justify-content-center'}>
            <IconButton
                onPressed={decrease}
                color={'secondary'}
                disabled={disabled || (Number(value) || 0) <= resolvedMin}
            >
                <Remove className={'icon small'}/>
            </IconButton>
            <div className={'quantity-field mx-1'} style={{width: 56}}>
                <TextField
                    size={'small'}
                    fullWidth
                    disabled={disabled}
                    inputProps={{min: resolvedMin, max}}
                    type={'number'}
                    sx={{
                        '& input': {
                            textAlign: 'center',
                            padding: '6px 4px',
                        },
                    }}
                    value={value ?? 0}
                    onBlur={(e) => {
                        if (e.target.value === '' || Number.isNaN(parseFloat(e.target.value))) {
                            onChange(0);
                        }
                    }}
                    onChange={(e) => applyValue(e.target.value)}
                />
            </div>
            <IconButton
                onPressed={increase}
                color={'secondary'}
                disabled={disabled || (Number(value) || 0) >= max}
            >
                <Add className={'icon small'}/>
            </IconButton>
        </div>
    );
};

export default QuantityStepper;
